import { IncomingHttpHeaders } from 'http';
import { match, anyPass } from 'ramda';
import { tabletDevices, otherDevicesTreatedAsTablets } from './devicesLookup';

export const headersIndicateIE = (userAgent: string): boolean => {
    return userAgent.includes('Trident');
};

export const getUserAgent = (headers: IncomingHttpHeaders) => headers['user-agent'] || '';
export const getReferer = (headers: IncomingHttpHeaders) => headers.referer || '';

export const headersIndicateMobile = (headers: IncomingHttpHeaders): boolean => {
    const userAgent = getUserAgent(headers);
    const accepts = headers.accept || '';
    const userAgentMatch = (regex: RegExp) => match(regex, userAgent).length > 0;

    // regex ripped from alice vendor/Alice/Extension/Mobile/Detect.php
    return anyPass([
        () => userAgent === '',
        () => accepts.includes('text/vnd.wap.wml'),
        () => accepts.includes('application/vnd.wap.xhtml+xml'),
        () => userAgentMatch(/android.*mobile/gi),
        () => userAgentMatch(/android(?!.*mobile)/gi),
        () => userAgentMatch(/rim tablet os/gi),
        () => userAgentMatch(/(iphone|ipod)/gi),
        () => userAgentMatch(/(ipad)/gi),
        () => userAgentMatch(/(avantgo|blazer|elaine|hiptop|palm|plucker|xiino)/gi),
        () => userAgentMatch(/windows ce; (iemobile|ppc|smartphone)/gi),
        () => userAgentMatch(/windows phone os/gi),
        () =>
            userAgentMatch(
                /(kindle|mobile|mmp|midp|pocket|psp|symbian|smartphone|treo|up.browser|up.link|vodafone|wap|opera mini)/gi
            ),
    ])();
};

export const headersIndicateTablet = (headers: IncomingHttpHeaders): boolean => {
    const userAgent = getUserAgent(headers);
    const devicesMerge = { ...tabletDevices, ...otherDevicesTreatedAsTablets };
    const regexPasses = Object.keys(devicesMerge).map(key => {
        return () => match(new RegExp(devicesMerge[key], 'gi'), userAgent).length > 0;
    });
    return anyPass(regexPasses)();
};

export const headersIndicateCrawler = (headers: IncomingHttpHeaders): boolean => {
    const userAgent = getUserAgent(headers).toLowerCase();
    return [
        'googlebot',
        'slurp',
        'bingbot',
        'duckduckbot',
        'yandexbot',
        'exabot',
        'facebot',
        'ia_archiver',
    ].some(value => userAgent.includes(value));
};

// regex built basing on https://www.keycdn.com/blog/web-crawlers and it's domains,
// written in Pure JS, cause exported to client
export const headersIndicateSearchPageReferer = (headers: IncomingHttpHeaders): boolean => {
    const referer = getReferer(headers);
    return [
        '/www.google.',
        '/www.yahoo.com',
        '/www.bing.com',
        '/www.duckduckgo.com',
        '//yandex.com',
        '/www.facebook.com',
    ].some(value => referer.includes(value));
};

export const headersIncidateSearchEngine = (headers: IncomingHttpHeaders): boolean => {
    return headersIndicateCrawler(headers) || headersIndicateSearchPageReferer(headers);
};
